<template>
  <div class="card-data">
    <Tooltip
    :tip="tip" 
    />
    <div class="card-title">
      <h5 class="title">Performance</h5>
    </div>
    <div v-if="!loader">
      <Loader/>
    </div>
    <!-- <div v-else-if="loader&&storeOfferClicks.length==0">
      <EmptyStateChart
      :title="titleEmpty"
      :caption="captionEmpty"
      />
    </div> -->
    

    <div class="performance" v-else-if="loader">
      <div class="revenue">
        <h6 class="subtitle">Revenue</h6>
        <div class="counter">
          <h4 class="value">$ {{actualRevenue}}</h4>
          <!-- <i class="ico-down-triangle-fill indicator down"></i> -->
        </div>
        <!-- <p class="pre-value">$ {{prevRevenue}}</p> -->
      </div>
      <!-- <hr>
      <div class="interactions-venue">
        <h6 class="subtitle">Interacciones por sucursal</h6> -->
        
        <!-- <div class="detailed-amount" v-for="(group, key) in detailed" :key="key"> TODO Revisar codigo @sebastianep
                <h4 class="amount">
                    <ICountUp
                        :endVal="percentage(group)"
                        :options="options"
                        /> %
                </h4>
                <p class="amount-group">{{detailedNames[key]}}</p>
            </div> -->

        <!-- <ul class="ranking-venue"> -->

        <!-- Esto es una cochinada hecha por KUKY -->
        <!-- Se debe cambiar para la siguiente versión -->
        <!-- <div class="" v-for="(click, key) in storesRanking" :key="key">
              <li class="spot">
                <small class="venue-name" v-if="click.node_mac == '33:33:33:33:33:33'">
                  Santiago </small>
                  <small class="venue-name" v-if="click.node_mac == '22:22:22:22:22:22'">
                  Concepción </small>
                  <small class="venue-name" v-if="click.node_mac == '11:11:11:11:11:11'">
                  Viña del Mar </small>
                <small class="venue-interactions">{{String(click.count).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}}</small>

              </li>
          </div> -->

        <!-- </ul>
      </div> -->
      <!-- <hr> -->
      <div class="engage-vigencia">
        <!-- <div class="engagement">
          <h6 class="subtitle">Engagement</h6>
          <h4 class="value">{{ engagementPercent }}%</h4>
        </div> -->
        <hr>
        <div class="vigencia">
          <h6 class="subtitle">Vigencia</h6>
          <h4 class="days-count">{{daysCount ? daysCount+ ' días' : 'Indefinido'}}</h4>
          <small class="dates">desde el {{fromDateES}} {{ toDateES ? "al "+ toDateES : ''}}</small>
        </div>
      </div>
      <hr>
      <small class="created">Creada: {{createdES}}</small>
    </div>
    
  </div>
</template>
<script>
import Tooltip from "@/components/Tooltip"
import Loader from "@/components/Loader"
import EmptyStateChart from '@/components/EmptyStateChart'

export default {
  name: 'PerformanceCard',
  components: {
    Tooltip,
    Loader,
    EmptyStateChart
  },
  props: {
    actualRevenue: {
      type: [String, Number],
      default:""
    },
    prevRevenue:{
      type: String,
      default:""
    },
    venueName:{
      type: String,
      default:""
    },
    venueInteractions:{
      type: String,
      default:""
    },
    engagement:{
      type: Number,
      default:""
    },
    daysCount:{
      type: Number,
      default:0
    },
    fromDate:{
      type: String,
      default:""
    },
    toDate:{
      type: String,
      default:""
    },
    created:{
      type: String,
      default:""
    },
    storeOfferClicks:{
      type: Array,
      required: true
    },
    loader: {
        type: Boolean,
        default: false
    },
    totalClicks: {
      type: Number
    },
    tip: {
            type: String,
            required: true
    },
    storesRanking: {
      type: Array,
      required: true
    },
    captionEmpty:{
        type: String,
        default: "Puedes consultar la vista de los últimos 7 o 30 días.",
    },
    titleEmpty: {
        type: String,
        default: "Este gráfico no esta disponible para esta vista"
    }
  },
  data(){
    return{
      //
    }
  },
  computed: {
    // engagementPercent: function (){
    //   var eng = this.totalClicks / this.engagement
    //   return parseFloat(eng).toFixed(4)
    // },
    fromDateES: function(){
      let monthNames = [
                                "Ene", "Feb", "Mar",
                                "Abr", "May", "Jun", "Jul",
                                "Ago", "Sep", "Oct",
                                "Nov", "Dic"
                            ]
      var fromdate = this.fromDate.split("-")
      return fromdate[2]+" de "+monthNames[this.fromDate.split('-')[1] - 1]+" de "+fromdate[0];
    },
    createdES: function(){
      let monthNames = [
                                "Ene", "Feb", "Mar",
                                "Abr", "May", "Jun", "Jul",
                                "Ago", "Sep", "Oct",
                                "Nov", "Dic"
                            ]
      var createdArr = this.fromDate.split("-")
      return createdArr[2]+" de "+monthNames[this.created.split('-')[1] - 1]+" de "+createdArr[0];
    },
    toDateES: function(){
      let monthNames = [
                                "Ene", "Feb", "Mar",
                                "Abr", "May", "Jun", "Jul",
                                "Ago", "Sep", "Oct",
                                "Nov", "Dic"
      ]
      if (this.toDate){
        var todate = this.toDate.split("-")
        return todate[2]+" de "+monthNames[this.toDate.split('-')[1] - 1]+" de "+todate[0];
      }
      else{
        return ""
      }
      
    },
  }
}
</script>
<style lang="sass">
.performance
  display: flex
  flex-direction: column
  justify-content: space-between
  hr
    width: 50%
    align-self: center
    margin: $sm 0
    opacity: 0.6
    height: 0px
    border: 0.5px solid $dark-grey
  h4
    width: 100%
    text-align: right
  small
    font-family: $body-font
  .revenue
    font-family: $title-font
    .counter
      display: flex
      flex-direction: row
      margin-top: $sm
      i
        margin-top: $xxs
    .value
      flex-grow: 2
      text-align: right
    .pre-value
      flex-grow: 2
      width: 100%
      text-align: right
      font-size: 14px
  .ranking-venue 
    margin-top: $sm
    .spot
      display: flex
      width: 100%
      margin-top: $xxs
      .venue-name
        flex-grow: 3
      .venue-interactions
        flex-grow: 1
        text-align: right
  .engage-vigencia
    display: flex
    flex-direction: column
    @include mobile
      flex-direction: row
      h4
        margin: $xs 0
    .engagement
      @include mobile
        width: 50%
        h6,h4
          text-align: center
    hr
      @include mobile
        display: none
    .vigencia
      padding-top: 50px
      display: flex
      flex-direction: column
      @include mobile
        width: 100% // cuando tengamos engagement hay que cambiar este valor a 50%
        h6
          text-align: left
        h4 
          display: none
      .dates
        width: 100%
        text-align: right
        margin-top: 2px
        @include mobile 
          text-align: center
          margin-top: $xs
  .created
    diplay: flex
    width: 100%
    text-align: center
    margin-bottom: $sm
</style>